'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  path: 'M9.21567432,23 L9.21567432,12.4986746 L7,12.4986746 L7,8.88027013 L9.21567432,8.88027013 L9.21567432,6.70790204 C9.21567432,3.75618531 10.4660977,2 14.0209307,2 L16.9796789,2 L16.9796789,5.61972987 L15.1304613,5.61972987 C13.7465962,5.61972987 13.6551514,6.12537869 13.6551514,7.06907978 L13.6490551,8.88027013 L17,8.88027013 L16.6078033,12.4986746 L13.6490551,12.4986746 L13.6490551,23 L9.21567432,23 Z',
  bgColor: '#3a5998',
  fill: '#FFFFFF',
  link: 'https://www.facebook.com/olxbrasil'
};